<template>
  <app-layout>
    <div class="flex items-start max-w-7xl mx-auto p-10 space-x-4 bg-white rounded-md shadow-xl">
      <div class="w-full">
        <div class="flex flex-col">
          <h1 class="border-b border-dark-blue text-4xl">
            Résultats du test de {{ invitation.first_name }} {{ invitation.last_name }}
            <span class="text-2xl">({{ invitation.email }})</span>
          </h1>
          <h4>Test effectué le {{ submission.date }}</h4>
        </div>
        <div class="flex justify-between">
          <div class="mt-8">
            <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 w-full">
              <div v-for="(skill, key) in scoreBySkill" class="bg-light-blue p-6 rounded-lg bg-30">
                <p class="font-bold">{{ skill.title }}</p>
                <div class="flex my-4">
                  <p :class="level(skill.level).style" class="py-1 px-4 rounded-full text-sm font-bold">{{ level(skill.level).text }}</p>
                </div>
                <p>Score : {{ skill.points }} / 6 </p>
              </div>
            </div>

            <div class="mt-8">
              <p class="text-lg font-bold mb-6">Détail des réponses par compétence</p>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
                <div v-for="(responses, skill) in responsesBySkill" class="p-4 bg-light-blue rounded-lg bg-30">
                  <p class="font-bold mb-2 py-2">{{ skill }}</p>
                  <p class="response mb-1 p-2" v-for="response in responses">{{ response.question_content.fr }} <strong>({{ response.points }})</strong></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import CoachResultsTable from "@/Components/CoachResultsTable";
import MazDialog from "maz-ui/components/MazDialog";
import NewInvitation from "@/Components/NewInvitation";
import BubbleButton from "@/Components/BubbleButton";

export default {
  name: 'Results',
  components: {
    AppLayout,
  },

  props: {
    invitation: Object,
    submission: Object,
    scoreBySkill: Object,
    responses: Object,
  },

  computed: {
    responsesBySkill() {
      return _.groupBy(this.responses, 'skill_title')
    },
  },

  methods: {
    level(result) {
      switch (result) {
        case ('develop'):
          return {
            'style': 'bg-red-500 text-white',
            'text': 'A développer'
          }
          break;
        case ('improve'):
          return {
            'style': 'bg-yellow-500',
            'text': 'A améliorer'
          }
          break;
        case ('maintain'):
          return {
            'style': 'bg-green-500 text-white',
            'text': 'A entretenir'
          }
          break;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.response:nth-child(even) {
  background-color: rgba(24, 39, 69, 0.05);
}
</style>
